export const name = "MAX";
export const summary = `Gets the maximum non-\`NULL\` value.`;
export const reference = `
## MAX

Gets the maximum non-\`NULL\` value.

\`\`\`
MAX(
  expression
)
[OVER over_clause]

over_clause:
  { named_window | ( [window_specification] ) }

window_specification:
  [named_window]
  [PARTITION BY partition_expression [, ...] ]
  [ORDER BY expression [ { ASC | DESC }] [, ...] ]
  [window_frame_clause]
\`\`\`

### Description

Returns the maximum non-\`NULL\` value in an aggregated group.

Caveats:

- If the aggregated group is empty or the argument is \`NULL\` for all rows in the group, returns \`NULL\`.
- If the argument is \`NaN\` for any row in the group, returns \`NaN\`.

To learn more about the optional aggregate clauses that you can pass into this function, see Aggregate function calls.

To learn more about the \`OVER\` clause and how to use it, see Window function calls.

This function supports specifying collation.


### Supported Argument Types

Any orderable data type except for \`ARRAY\`.


### Return Data Types

The data type of the input values.


### Examples



\`\`\`
SELECT MAX(x) AS max
FROM UNNEST([8, 37, 55, 4]) AS x;

/*-----*
 | max |
 +-----+
 | 55 |
 *-----*/
\`\`\`



\`\`\`
SELECT x, MAX(x) OVER (PARTITION BY MOD(x, 2)) AS max
FROM UNNEST([8, NULL, 37, 55, NULL, 4]) AS x;

/*------+------*
 | x | max |
 +------+------+
 | NULL | NULL |
 | NULL | NULL |
 | 8 | 8 |
 | 4 | 8 |
 | 37 | 55 |
 | 55 | 55 |
 *------+------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/aggregate_functions
`;
